import withLazyLoading from '../../hoc/withLazyLoading';
import { createCrumbHandle } from '../../utilities/auth';
import { Navigate } from 'react-router-dom';

import withPostHogTracker from '../../composeRouter';
import { ISSUE_RULES, PLANT_RULES, TASK_RULES, access, param } from '../../access';

const AlertTaskConfig = withLazyLoading(() => import('../../pages/AlertTaskConfig'));
const ManualAlertConfig = withLazyLoading(() => import('../../pages/ManualAlertConfig'));
const Ticketsv2 = withLazyLoading(() => import('../../pages/Ticketsv2'));
const CreateTaskPage = withLazyLoading(
  () => import('../../components/TaskTemplate/pages/CreateTaskPage')
);
const TaskTemplateList = withLazyLoading(
  () => import('../../components/TaskTemplate/components/TaskTemplateList')
);
const ResponsiveTaskView = withLazyLoading(
  () => import('../../components/OperatorTask/components/ResponsiveTaskView')
);
const WorkflowCreator = withLazyLoading(
  () => import('../../components/Workflow/components/WorkflowCreator')
);
const EditSkill = withLazyLoading(() => import('../../components/EditSkill/components/SearchSkill'));
const RosterCreator = withLazyLoading(
  () => import('../../components/RoasterCalendar/components/RosterCreator')
);
const RoasterPlanningList = withLazyLoading(
  () => import('../../components/RoasterPlanning/components/RoasterPlanningList')
);
const WorkflowList = withLazyLoading(
  () => import('../../components/Workflow/components/WorkflowList')
);


const taskRoutes = [
  {
    path: '/taskTemplates',
    handle: createCrumbHandle('Fixed Tasks Configuration'),
    children: [
        {
            index: true,
            element: <TaskTemplateList />,
            handle: access(TASK_RULES.templates),
        },
        {
            path: 'taskTemplate/:taskTemplateId?',
            element: <CreateTaskPage />,
            handle: { ...createCrumbHandle('Create Task'), ...access(TASK_RULES.createTemplate) },
        },
    ]
  },
  {
    path: '/taskListPage',
    element: withPostHogTracker(<ResponsiveTaskView />),
    handle: { ...createCrumbHandle('Tasks'), ...access(TASK_RULES.shifts) },
  },
  {
    path: '/task-list',
    element: <Navigate to="/taskListPage" replace />,
    handle: access(TASK_RULES.shifts),
  },
  {
    path: '/alertTasksConfig/:id',
    element: <AlertTaskConfig />,
    handle: { ...createCrumbHandle('Alert Tasks Configuration'), ...access(PLANT_RULES.alertRules, param('id')) },
  },
  {
    path: '/manualAlertsConfig/:id',
    element: <ManualAlertConfig />,
    handle: { ...createCrumbHandle('Manual Alerts Configuration'), ...access(PLANT_RULES.alertRules, param('id')) },
  },
  {
    path: '/tickets',
    element: withPostHogTracker(<Ticketsv2 />),
    handle: { ...createCrumbHandle('Tickets'), ...access(ISSUE_RULES.view) },
  },
  {
    path: '/workflows',
    handle: createCrumbHandle('Workflows'),
    children: [
        {
            index: true,
            element: <WorkflowList />,
            handle: access(TASK_RULES.workflows),
        },
        {
            path: 'editWorkflow/:workflowId?',
            element: <WorkflowCreator />,
            handle: { ...createCrumbHandle('Create Workflow'), ...access(TASK_RULES.createWorkflow) },
        },
    ]
  },
  {
    path: '/skill',
    element: <EditSkill />,
    handle: { ...createCrumbHandle('Skills'), ...access(TASK_RULES.skills) },
  },
  {
    path: '/rosterPlan',
    handle: createCrumbHandle('Rosters'),
    children: [
        {
            index: true,
            element: <RoasterPlanningList />,
            handle: access(TASK_RULES.shifts),
        },
        {
            path: 'roster/:rosterId?',
            element: <RosterCreator />,
            handle: { ...createCrumbHandle('Create Roster'), ...access(TASK_RULES.planShifts) },
        },
    ]
  },
];

export default taskRoutes;
